export default __webpack_public_path__ + "static/media/boc.b751cfc6.svg";